import React, { useState } from "react";
import procedureDiagnosisService from "../procedureDiagnosis/procedureDiagnosisService";
import ImageService from "../images/imageService"; // ✅ Your shared image service
import TooltipInput from "../../NewUPT/ToolTip/TooltipInput";
import "../registration/ptRegDesign.css";

const diagService = new procedureDiagnosisService();

const RegisterProcedureDiagnosis = () => {
  const [form, setForm] = useState({
    code: "",
    description: "",
    differenceCode: "",
  });

  const [uploadedFilename, setUploadedFilename] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    if (!form.code) {
      setMessage("Please enter a Code before uploading an image.");
      return;
    }

    if (file) {
      setUploading(true);
      try {
        const filename = `${form.code.trim()}.png`;
        const uploadedPath = await ImageService.uploadImage(file, filename, "procedurediagnosis");

        const uploadedFile = uploadedPath.split("/").pop();
        setUploadedFilename(uploadedFile);
        setPreviewUrl(ImageService.getImageUrl("procedurediagnosis", uploadedFile));
        setMessage("Image uploaded successfully.");
      } catch (error) {
        console.error("Image upload error:", error);
        setMessage("Failed to upload image.");
      } finally {
        setUploading(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const itemDetail = {
      code: form.code.trim(),
      description: form.description.trim(),
      differenceCode: form.differenceCode.trim(),
      picture: uploadedFilename || "", // only store file name
    };

    try {
      const response = await diagService.addProcedure(itemDetail);
      setMessage("Procedure/Diagnosis Registered!");
      setForm({ code: "", description: "", differenceCode: "" });
      setUploadedFilename("");
      setPreviewUrl("");
    } catch (error) {
      setMessage("Registration Failed: " + error.message);
    }
  };

  return (
    <div className="form-wrapper">
      <form id="procedureDiagnosisRegistrationForm" onSubmit={handleSubmit}>
        <TooltipInput
          type="text"
          id="code"
          placeholder="Enter Code"
          tooltip="Unique code for the item."
          value={form.code}
          onChange={(v) => handleChange("code", v)}
        />
        <TooltipInput
          type="text"
          id="description"
          placeholder="Enter Description"
          tooltip="Detailed description of the item."
          value={form.description}
          onChange={(v) => handleChange("description", v)}
        />

        <div className="input-container">
          <label htmlFor="picture">Upload Picture (Optional)</label>
          <input
            type="file"
            id="picture"
            accept="image/*"
            onChange={handleFileChange}
          />
        </div>

        {previewUrl && (
          <div className="image-preview">
            <img src={previewUrl} alt="Preview" />
          </div>
        )}

        <TooltipInput
          type="text"
          id="differenceCode"
          placeholder="Enter Difference Code"
          tooltip="Code specifying differences."
          value={form.differenceCode}
          onChange={(v) => handleChange("differenceCode", v)}
        />
        <button type="submit" disabled={uploading}>
          {uploading ? "Saving..." : "Register Procedure/Diagnosis"}
        </button>

        {message && <p className="message">{message}</p>}
      </form>
    </div>
  );
};

export default RegisterProcedureDiagnosis;
